import {Spine} from 'pixi-spine';
import * as PIXI from 'pixi.js';
import {Container, Text} from 'pixi.js';
import {container} from 'tsyringe';
import AssetsManager from '../../../core/assets/AssetsManager';
import LayoutBuilder from '../../../core/utils/LayoutBuilder';
import {autoscaleText} from '../../../core/utils/Utils';
import LayoutElement from '../../../core/view/model/LayoutElement';
import Wallet from '../../../slots/model/Wallet';
import {FreeSpinsAnimation} from './PopupFreeSpinAnimationType';
import { TRANSLATIONS } from '../../../../jewels-of-wizard/services/text-json-files/DataSource';
import SlotMachine from '../../../slots/model/SlotMachine';
import { SpinResult } from '../../../slots/model/RoundResult';

export default class PopupFreespinsHorizontal extends Container {
    // VISUALS
    public animation: Spine;
    // public tfAmount: Text | BitmapText;
    public tfFreeSpinNumber: Text
    private animationDuration = 2;
    private freespinEndvalue: boolean
    public amt: Text ;
    private amounttext:Text
    private youHaveWonText: Text;
    private freeSpin: Text;
    private pressAnywhereText: Text;
    private freeSpinsAnimations: {
    BUY_FREESPIN_APPEAR : string,
    BUY_FREESPIN_DISAPPEAR : string,
    BUY_FREESPIN_LOOP : string,

    FREESPIN_APPEAR : string,
    FREESPIN_APPEAR_MOBILE : string,
    FREESPIN_DISAPPEAR : string,
    FREESPIN_DISAPPEAR_MOBILE : string,
    FREESPIN_LOOP : string,
    FREESPIN_LOOP_MOBILE : string,

    IN15FREESPIN_APPEAR : string,
    IN15FREESPIN_APPEAR_MOBILE : string,
    IN15FREESPIN_DISAPPEAR : string,
    IN15FREESPIN_DISAPPEAR_MOBILE : string,
    IN15FREESPIN_LOOP : string,
    IN15FREESPIN_LOOP_MOBILE : string,
    };
    constructor(private lang: string, amount: number | (() => number),totalFreespinCount:number = 0, freeSpinEnd: boolean = false, totalFreespin: boolean = true) {
        super();

        this.freespinEndvalue = freeSpinEnd
        // DisplayShortcuts.init();

        LayoutBuilder.create(AssetsManager.layouts.get('PopupFreespins'), this, (le: LayoutElement) => {
            return this.customClassElementCreate(le);
        });
        this.freeSpinsAnimations = FreeSpinsAnimation[this.lang] ?? FreeSpinsAnimation[TRANSLATIONS.EN]
        let amt = (amount instanceof Function ? amount() : amount);
        const style = new PIXI.TextStyle({
            fontFamily: AssetsManager.getWebFontFamily('Rokkitt'),
            dropShadow: true,
            dropShadowAngle: 1.5,
            dropShadowBlur: 2,
            dropShadowColor: '#FF17B9',
            dropShadowDistance: 4,
            stroke: '#410456',
            strokeThickness: 3,
            fill: '#FFE614',
            fontSize: 65,
            // fontWeight: "bolder"
        });
        const wallet: Wallet = container.resolve(Wallet);
        const sm: SlotMachine = container.resolve(SlotMachine);
        const spinResult: SpinResult = sm.currentSpinResult;

        if(spinResult.freespins.IsmoreAwarded){
            amt = spinResult.freespins.moreAwarded
            this.amounttext = new PIXI.Text("+ "+ wallet.getCurrencyValue(amt, false), style);
        }else{
            this.amounttext = new PIXI.Text( wallet.getCurrencyValue(amt, false), style);
        }
        this.amounttext.anchor.set(0.5);
        this.amounttext.scale.set(1, -1)

        if (this.freespinEndvalue) {
            this.amounttext = new PIXI.Text(wallet.getCurrencyValue(amt, true), style);
            this.amounttext.anchor.set(0.5);
            this.amounttext.scale.set(1, -1);
            autoscaleText(this.amounttext, 120, 250, 100);

            this.tfFreeSpinNumber = new Text(`${AssetsManager.translations.get('freeSpins.in')}${totalFreespinCount} ${AssetsManager.translations.get('freeSpins.freeSpinEnd')}`, {
                fontFamily: AssetsManager.getWebFontFamily('Rokkitt'),
                fill: ['#4ad5ff'],
                fontSize: 74,
                lineJoin: 'round',
                fontWeight:'bold'
            })
            autoscaleText(this.tfFreeSpinNumber, 74, 600, 100);
            this.tfFreeSpinNumber.anchor.set(0.5, 0.5);
            this.tfFreeSpinNumber.scale.set(1, -1)
            this.tfFreeSpinNumber.position.set(12,-10)
        }

        const style2 = new PIXI.TextStyle({
            fontFamily: AssetsManager.getWebFontFamily('Rokkitt'),
            fill: ['#4ad5ff'],
            fontSize: 74,
            lineJoin: 'round',
            fontWeight:'bold'
        })

        this.youHaveWonText = new Text(AssetsManager.translations.get('freeSpins.youHaveWon'), style2);
        if(!totalFreespin && !spinResult.freespins.IsmoreAwarded)
            this.youHaveWonText.text = AssetsManager.translations.get('freeSpins.youHaveLeft')
        
        this.freeSpin = new Text(AssetsManager.translations.get('freeSpins.freeSpin'), style2);
        this.freeSpin.anchor.set(0.5);
        this.freeSpin.scale.set(1, -1);
        this.freeSpin.position.set(0,-15);
        this.youHaveWonText.anchor.set(0.5);
        this.youHaveWonText.scale.set(1, -1);

        this.pressAnywhereText = new Text(AssetsManager.translations.get('freeSpins.pressAny'), {
            fontFamily: AssetsManager.getWebFontFamily('Rokkitt'),
            fill: ['white'],
            fontSize: 25,
        });
        this.pressAnywhereText.anchor.set(0.5);
        this.pressAnywhereText.scale.set(1, -1);

        this.animation = new Spine(AssetsManager.spine.get('freegame_anim'))
        this.addChild(this.animation)
        setTimeout(()=>{
            const pressAnyWhereContainer: Container = this.animation.slotContainers[this.animation.skeleton.findSlotIndex('placeholder5')];
                pressAnyWhereContainer.removeChildren();
                pressAnyWhereContainer.addChild(this.pressAnywhereText);

                if (this.freespinEndvalue) {
                    if(AssetsManager.translations.get('freeSpins.in') == ''){
                        const youHaveWonContainer: Container = this.animation.slotContainers[this.animation.skeleton.findSlotIndex('placeholder2')];
                        youHaveWonContainer.removeChildren();
                        youHaveWonContainer.addChild(this.youHaveWonText);
                        this.tfFreeSpinNumber.position.set(0,-15)
                        const inFreeSpinContainer2: Container = this.animation.slotContainers[this.animation.skeleton.findSlotIndex('placeholder4')];
                        inFreeSpinContainer2.removeChildren();
                        inFreeSpinContainer2.addChild(this.tfFreeSpinNumber);
                    }else{
                        const youHaveWonContainer: Container = this.animation.slotContainers[this.animation.skeleton.findSlotIndex('placeholder4')];
                    youHaveWonContainer.removeChildren();
                    youHaveWonContainer.addChild(this.youHaveWonText);
                    const inFreeSpinContainer2: Container = this.animation.slotContainers[this.animation.skeleton.findSlotIndex('placeholder2')];
                    inFreeSpinContainer2.removeChildren();
                    inFreeSpinContainer2.addChild(this.tfFreeSpinNumber);
                }
                this.youHaveWonText.position.set(0,0);
                const inFreeSpinContainer: Container = this.animation.slotContainers[this.animation.skeleton.findSlotIndex('placeholder7')];
                inFreeSpinContainer.removeChildren();
                inFreeSpinContainer.addChild(this.amounttext);

            }else{
                const youHaveWonContainer: Container = this.animation.slotContainers[this.animation.skeleton.findSlotIndex('placeholder4')];
                youHaveWonContainer.removeChildren();
                youHaveWonContainer.addChild(this.youHaveWonText);

                const freeSpinContainer: Container = this.animation.slotContainers[this.animation.skeleton.findSlotIndex('placeholder1')];
                freeSpinContainer.removeChildren();
                freeSpinContainer.addChild(this.freeSpin);

                const counterContainer: Container = this.animation.slotContainers[this.animation.skeleton.findSlotIndex('placeholder7')];
                counterContainer.removeChildren();
                counterContainer.addChild(this.amounttext);
            }
        },500)

        this.on('removed', this.onRemoved, this);
        this.on('added', this.onAdded, this);
    }


    // PRIVATE API
    private customClassElementCreate(le: LayoutElement): unknown {
        const instance: unknown = null;

        switch (le.customClass) {
            case 'FreespinsAnimation':
                // instance = new Spine(AssetsManager.spine.get('freegame_anim'));
                break;
            }

            return instance;
        }

        private onAdded(): void {
            this.animation.state.setEmptyAnimations(0);
            this.animation.state.setAnimation(0, this.freeSpinsAnimations.FREESPIN_APPEAR, false);
            this.animation.state.addAnimation(0, this.freeSpinsAnimations.FREESPIN_LOOP, true, 0);
            if (this.freespinEndvalue) {
                setTimeout(()=>{
                    this.animation.state.setAnimation(0, this.freeSpinsAnimations.IN15FREESPIN_APPEAR, false);
                    this.animation.state.addAnimation(0, this.freeSpinsAnimations.IN15FREESPIN_LOOP, true, 0);
                },100)
            }
        }

        private onRemoved(): void {
            this.animation.state.setEmptyAnimations(0);
            this.animation.state.clearListeners();
        this.animation['lastTime'] = null;
    }
}




